import { Component, ReactNode } from 'react'
import { Error } from '../../pages'

type ErrorBoundaryState = { error: any }

class ErrorBoundary extends Component<{ children: ReactNode }, ErrorBoundaryState> {
  static getDerivedStateFromError(error: any) {
    return { error }
  }

  constructor(props: any) {
    super(props)
    this.state = { error: null }
  }

  componentDidCatch(error: any) {
    if (error?.error) {
      this.setState({ error: error.error })
    } else {
      this.setState({ error })
    }
  }

  get errorMessage() {
    const error = this.state.error
    if (!error) {
      return ''
    }
    if (typeof error === 'string') {
      return error
    }
    return (error.code ? `${error.code}: ${error.message}` : error.message) || 'Unexpected error'
  }

  get errorName() {
    const error = this.state.error
    if (!error) {
      return null
    }

    return error.name ?? 'Unexpected error'
  }

  render() {
    if (this.state.error) {
      return <Error name={this.errorName} description={this.errorMessage} />
    }
    return this.props.children
  }
}

export { ErrorBoundary }
